import { FC } from "react";
import { Text, View } from "react-native";
import { RoleModel } from "app/services/api/types/roles/models/RoleModel";

interface Props {
  role: RoleModel;
}

export const RoleContent: FC<Props> = ({ role }) => {
  return (
    <View>
      <View className="flex flex-col py-3">
        <Text className="text-gray-600 mb-2">Role</Text>
        <Text className="font-semibold">{role.display_name}</Text>
      </View>
      <View className="flex flex-col py-3">
        <Text className="text-gray-600 mb-2">Role manager</Text>
        <Text>{role.parent ? role.parent?.display_name : "None assigned"}</Text>
      </View>
    </View>
  );
};
